import React from 'react';
import { Newsletter } from 'ech-components/src/components';
import { createRoutingURI, getRootSlug } from '@scripts/utils/domain';
import { Grid, GridItem } from 'ech-components/src/helpers';

const newsletterModuleService = (data: {
  title: string;
  buttonText: string;
  page: {
    slug: string;
    node_locale: string;
  };
}) => {
  return (
    <Newsletter
      header={data.title}
      button={data.buttonText}
      newsletterHref={createRoutingURI(
        getRootSlug(data.page, data.page.node_locale),
      )}
    />
  );
};

export default newsletterModuleService;
